import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { toast, Toaster } from "sonner";
import { BadgeCheck, Clock, X, Trash2 } from "lucide-react";

export default function AdminDoctorsRegistered() {
    const [items, setItems] = useState([]);
    const load = () => api.get("/admin/doctors/registered").then(r => setItems(r.data));
    useEffect(() => { load(); }, []);

    const setStatus = async (id, status) => {
        try { await api.put(`/admin/doctors/registered/${id}/status`, null, { params: { status } }); toast.success("Updated"); load(); }
        catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    };
    const del = async (d) => {
        if (!window.confirm(`Permanently delete doctor "${d.name}"?\n\nThe linked user account stays for historical references — block them in Admin → Users if needed.`)) return;
        try { await api.delete(`/admin/doctors/registered/${d.id}`); toast.success("Doctor deleted"); load(); }
        catch (e) { toast.error(e.response?.data?.detail || "Delete failed"); }
    };

    return (
        <div data-testid="admin-doctors-registered">
            <Toaster position="top-center" />
            <div className="label-eyebrow text-sky-700">Moderation</div>
            <h1 className="font-serif text-4xl text-stone-900 mt-2 mb-8">Registered doctors</h1>

            <div className="bg-white border border-stone-200">
                {items.map((d) => (
                    <div key={d.id} className="border-b border-stone-100 last:border-b-0 p-4 grid grid-cols-12 gap-3 items-center" data-testid={`reg-row-${d.id}`}>
                        <div className="col-span-3"><div className="font-medium">{d.name}</div><div className="text-xs text-stone-500">{d.email} · {d.phone}</div></div>
                        <div className="col-span-2 text-xs">{d.qualification}<br /><span className="text-stone-500">{d.specialization}</span></div>
                        <div className="col-span-2 text-xs">{d.city}{d.state ? `, ${d.state}` : ""}<br /><span className="text-stone-500">{d.experience_years} yrs</span></div>
                        <div className="col-span-2 text-xs">
                            {d.online_consult && <span className="border border-sky-700 text-sky-700 px-2 py-0.5 mr-1">Online</span>}
                            {d.offline_consult && <span className="border border-stone-700 text-stone-700 px-2 py-0.5">Clinic</span>}
                        </div>
                        <div className="col-span-1">
                            <span className={`text-xs uppercase tracking-widest px-2 py-1 ${d.status === "approved" ? "text-sky-700" : d.status === "pending" ? "text-amber-700" : "text-red-700"}`}>
                                {d.status === "approved" && <BadgeCheck className="w-3 h-3 inline mr-1" />}
                                {d.status === "pending" && <Clock className="w-3 h-3 inline mr-1" />}
                                {d.status}
                            </span>
                        </div>
                        <div className="col-span-2 flex gap-1 justify-end">
                            {d.status !== "approved" && <Button size="sm" onClick={() => setStatus(d.id, "approved")} className="rounded-none bg-sky-700 hover:bg-sky-800 text-stone-50" data-testid={`approve-${d.id}`}><BadgeCheck className="w-3.5 h-3.5" /></Button>}
                            {d.status !== "rejected" && <Button size="sm" variant="outline" onClick={() => setStatus(d.id, "rejected")} className="rounded-none text-red-700 border-red-300" data-testid={`reject-${d.id}`} title="Reject"><X className="w-3.5 h-3.5" /></Button>}
                            <button
                                onClick={() => del(d)}
                                className="text-red-600 hover:text-white hover:bg-red-600 border border-red-200 hover:border-red-600 px-2 py-1 transition-colors inline-flex items-center text-xs"
                                title="Permanently delete doctor profile"
                                data-testid={`doctor-del-${d.id}`}
                            >
                                <Trash2 className="w-3.5 h-3.5" />
                            </button>
                        </div>
                    </div>
                ))}
                {items.length === 0 && <div className="p-8 text-center text-sm text-stone-500">No registered doctors yet.</div>}
            </div>
        </div>
    );
}
